import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DarkmodeService } from 'src/app/_provider/darkmode.service';

@Component({
  selector: 'app-notification-start',
  templateUrl: './notification-start.component.html',
  styleUrls: ['./notification-start.component.scss'],
})
export class NotificationStartComponent implements OnInit {

  constructor(
    private modalCtrl: ModalController,
    public darkmode: DarkmodeService
  ) { }

  ngOnInit() {}

  public async close(result: boolean){
    await this.modalCtrl.dismiss(result)
  }

}
